import ClientModule from "@gqlapp/module-client-react";
import Route from "@lib/Route";
import List from "@modules/photo/components/list";
import {defaultRoute, getProps} from "@modules/photo/helpers/config";

export default new ClientModule({
	route:{ TaxonomyGallery: <Route {...getProps(defaultRoute, List, { classNameOnPage: 'taxonomy taxonomy-gallery' })} /> }
});
